import { getBodyElement } from "../../../exports/dom";
import { onInit } from "../../../exports/tracking";
import { withSpan } from "../../../exports/apm";
import { runWithRenderSlice } from "../../../exports/core";
import { loggerScope } from "../parser/utils.js";
import { getTrackableElements } from "../parser/elements.js";
import { withInitLock } from "./defer.js";
import { registerTrackingHandler, unregisterTrackingHandler } from "./register.js";

const log = loggerScope.scope("init");

const BatchSize = 5;
const nextBatch = new Set<HTMLElement>();

const processNextBatch = (): void => {
  /*                                                                               */
  if (nextBatch.size === 0) return;

  /*                                                                */
  const batch = Array.from(nextBatch);
  nextBatch.clear();

  /*                                                           */
  runWithRenderSlice(() => {
    log.debug("Processing tracking batch of size", batch.length);
    batch.forEach((e) => withInitLock(e, registerTrackingHandler));
  });
};

/**
 *
 *
 *
 *
 *
 *
 */
export const addToNextBatch = (el: HTMLElement): void => {
  nextBatch.add(el);
  if (nextBatch.size < BatchSize) return;
  processNextBatch();
};

/*                                                                    */
export const observer = new MutationObserver((mutations) => {
  /*                                                              */
  /*                       */

  mutations
    .filter((m) => m.type === "childList")
    .forEach((mutation) => {
      const elementsToTrack = getTrackableElements(mutation.addedNodes);
      elementsToTrack.forEach((e) => withInitLock(e, registerTrackingHandler));

      const removedElements = getTrackableElements(mutation.removedNodes);
      removedElements.forEach(unregisterTrackingHandler);
    });

  /*                    */
  /*  */
});

/**
 *
 *
 *
 *
 *
 */
export const initDataTracker = withSpan(
  async function (this): Promise<void> {
    log.info("Initialize tracking system");

    /*                                            */
    /*                                                  */
    /*                          */
    await Promise.race([
      new Promise<void>((r) => setTimeout(r, 1000)),
      new Promise<void>((r) => onInit.sub(r, { once: true })),
    ]);

    /*                                                                             */
    return runWithRenderSlice(() => {
      log.info("Bootstrap tracking system");
      /*                                                           */
      /*                                                             */
      const theBody = getBodyElement();
      const elementsToTrack = getTrackableElements([theBody]);
      elementsToTrack.forEach(addToNextBatch);
      processNextBatch();

      /*                                            */
      this?.addLabels({ gr_tracking_element_count: elementsToTrack.length });

      log.info("initialize MutationObserver for tracking");
      observer.observe(theBody, { childList: true, subtree: true });
    });
  },
  "Init Tracking Wrapper",
  "module-init.global-resources.tracking",
);
